import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { getPresumedLevelName, parseDate, teacherLevel, TEACHING_QUAL_AUSTRALIA_WITH_EXP, TEACHING_QUAL_OVERSEAS_WITH_EXP, TEACHING_QUAL_AUSTRALIA_NO_EXP, TEACHING_QUAL_OVERSEAS_NO_EXP } from "../../Helper"
import PayLevelForm from "./PayLevelForm"

class PayLevel extends React.Component {
  constructor(props) {
    super(props);
    const payLevel = props.user?.pay_level || {};
    
    this.state = {
      payslip_filename: payLevel?.payslip_filename,
      payslip_url: payLevel?.payslip_url,
      letter_filename: payLevel.letter?.letter_filename,
      letter_url: payLevel.letter?.letter_url,
      status: payLevel?.status,
      category_name: payLevel?.category_name,
      presumed_level: payLevel?.presumed_level,
      presumed_level_number: payLevel?.presumed_level_number,
    };
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { category_name, letter_filename, letter_url, payslip_filename, payslip_url, presumed_level_number } = this.state

    let status = category_name === TEACHING_QUAL_AUSTRALIA_NO_EXP || category_name === TEACHING_QUAL_OVERSEAS_NO_EXP ? 'accepted' : 'uploaded'
    let presumed_level = ""
    let payLevel = {
      category_name,
      status: status,
      presumed_level: teacherLevel.JUNIOR,
      previous_level: this.props.user.level,
      uploaded_at: new Date(),
    }

    if (!category_name) {
      notify.show("Please choose the option that best describes you!")
      return;
    }

    if (category_name === TEACHING_QUAL_AUSTRALIA_WITH_EXP) {
      if (!(+presumed_level_number) && (+presumed_level_number != 0)) {
        notify.show("Please select your presumed level of pay!")
        return;
      }

      if (!payslip_filename || !payslip_url) {
        notify.show("Please upload your payslip!")
        return;
      }
      presumed_level = getPresumedLevelName(+presumed_level_number)

      payLevel = {
        ...payLevel,
        payslip_filename,
        payslip_url,
        presumed_level_number: +presumed_level_number,
        presumed_level,
      }
    }

    if (category_name === TEACHING_QUAL_OVERSEAS_WITH_EXP) {
      if (!letter_filename || !letter_url) {
        notify.show("Please upload at least 1 letter!")
        return;
      }
      payLevel = {
        ...payLevel,
        letter: {
          letter_filename,
          letter_url,
        },
        presumed_level: ""
      }
    }

    this.props.updatePersonalDetails({ pay_level: payLevel })
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  getTabs = () => {
    const tabs = [
      {
        pathname: "/personalid",
        text: "Personal ID",
      },
      {
        pathname: "/visa",
        text: "Visa Details",
      },
      {
        pathname: "/policecheck",
        text: "Police Check (Opt.)",
      },
      {
        pathname: "/wwcc",
        text: "WWCC (Optional)",
      },
      {
        pathname: "/usiCheck",
        text: "USI Check (Opt.)",
      },
      {
        pathname: "/uploadPayLevel",
        text: "Pay Level Evidence",
        active: true,
      }
    ]

    if (this.props.user?.is_childhood_teacher) {
      tabs.push({
        pathname: "/ececcheck",
        text: "First AID",
      });
    }

    return tabs
  }

  tabs = this.getTabs()

  
  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Pay Level Evidence"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
          disabled={this.state?.status === "uploaded"}
        >
          <PayLevelForm
            handleStateChange={this.handleStateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            state={this.state}
            user={this.props.user}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PayLevel)
